export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q04_a.bd3f5832.png";